import React, { useMemo } from 'react';
import { Building2, Eye, Shield, BarChart3 } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import { themeClasses } from '../../config/themeClasses';
import { Card } from '../UI/card';
import SupplyChainMap from '../Maps/SupplyChainMap';
import { buildLandingMapMarkers, buildLandingMapRoutes } from './landingDemoData';

const MOCK_KPIS = [
  { icon: Building2, valueKey: 'landingPreviewKpiCompanies', labelKey: 'totalCompanies' },
  { icon: Eye, valueKey: 'landingPreviewKpiWatchlist', labelKey: 'watchlistTitle' },
  { icon: Shield, valueKey: 'landingPreviewKpiRisk', labelKey: 'highRisk' },
  { icon: BarChart3, valueKey: 'landingPreviewKpiRoutes', labelKey: 'routes' },
];

export default function LandingProductPreview() {
  const { t } = useLocale();
  const markers = useMemo(() => buildLandingMapMarkers(t), [t]);
  const routes = useMemo(() => buildLandingMapRoutes(), []);

  return (
    <section className={themeClasses.landing.section}>
      <div className={themeClasses.landing.containerWide}>
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-display-lg">{t('landingPreviewTitle')}</h2>
          <p className="text-body-lg mt-4">{t('landingPreviewSubtitle')}</p>
        </div>

        <Card className={`${themeClasses.appKit.sectionShell} mt-12 overflow-hidden p-0`}>
          <div className="grid grid-cols-2 gap-px bg-border-light sm:grid-cols-4">
            {MOCK_KPIS.map(({ icon: Icon, valueKey, labelKey }) => (
              <div
                key={valueKey}
                className="flex flex-col gap-2 bg-background-card p-5 sm:p-6"
              >
                <div className="flex items-center gap-2">
                  <Icon className="size-4 text-text-tertiary" aria-hidden />
                  <span className="text-xs text-text-tertiary">{t(labelKey)}</span>
                </div>
                <span className="text-2xl font-semibold tracking-tight text-text-primary">
                  {t(valueKey)}
                </span>
              </div>
            ))}
          </div>

          <div className="relative h-56 border-t border-border-light sm:h-64">
            <SupplyChainMap
              markers={markers}
              routes={routes}
              compact
              minHeight={224}
              className="h-full"
            />
          </div>
        </Card>
      </div>
    </section>
  );
}
